'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SocialLinkedinOriginalAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2 4.66881C2 4.02529 2.22523 3.49441 2.67568 3.07614C3.12612 2.65786 3.71172 2.44873 4.43243 2.44873C5.14029 2.44873 5.71299 2.65464 6.15058 3.06649C6.60102 3.4912 6.82626 4.0446 6.82626 4.72672C6.82626 5.34448 6.60747 5.85927 6.16988 6.27112C5.71944 6.69584 5.12741 6.90819 4.39382 6.90819H4.37452C3.66666 6.90819 3.09396 6.69584 2.65637 6.27112C2.21878 5.84641 2 5.3123 2 4.66881ZM2.25097 21.5607V8.66495H6.53668V21.5607H2.25097ZM8.9112 21.5607H13.1969V14.3599C13.1969 13.9095 13.2484 13.562 13.3514 13.3175C13.5315 12.8799 13.805 12.5099 14.1718 12.2074C14.5386 11.905 14.9987 11.7538 15.5521 11.7538C16.9936 11.7538 17.7143 12.7254 17.7143 14.6688V21.5607H22V14.1669C22 12.2621 21.5496 10.8175 20.6486 9.8329C19.7477 8.84834 18.5573 8.35607 17.0772 8.35607C15.417 8.35607 14.1236 9.07035 13.1969 10.4989V10.5375H13.1776L13.1969 10.4989V8.66495H8.9112C8.93693 9.07678 8.94981 10.3573 8.94981 12.5066C8.94981 14.6559 8.93693 17.6739 8.9112 21.5607Z",
        fill: "#0A66C2"
      }
    )
  }
);
const VpSocialLinkedinOriginalAsset = forwardRef(SocialLinkedinOriginalAsset);

export { VpSocialLinkedinOriginalAsset as default };
